import React from 'react';
import './DegreeTypeSelector.scss';

export default props => {
  const propsToOmit = ['DegreeTypes'];
  let spreadProps = {};

  Object.keys(props).forEach((value) => {
    if (propsToOmit.indexOf(value) === -1) {
      if (value !== 'defaultValue') {
        spreadProps[value] = props[value];
      } else {
        spreadProps[value] = props[value];
      }
    }
  });

  return (
    <select {...spreadProps}>
      <option value=''>Please select</option>
      {(props.DegreeTypes || []).map(degreetypes => (
        <option className='DegreeTypeSelector__Suggestion' value={degreetypes.id} key={degreetypes.id}>{degreetypes.name}</option>
      ))}
    </select>
  );
};



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/Education/components/DegreeTypeSelector/index.js